
import {
  Component,
  Emit,
  PropSync,
  Watch,
  mixins,
} from 'nuxt-property-decorator'
import AuthMixin from '~/utils/mixins/authMixin'

const components = {
  BasicSwitch: () => import('@/components/shared/form/BasicSwitch.vue'),
  BasicNumberInput: () =>
    import('@/components/shared/form/BasicNumberInput.vue'),
}

@Component({ components })
export default class RoyaltyForm extends mixins(AuthMixin) {
  @PropSync('amount', { type: Number, required: true }) vRoyalty!: number
  @PropSync('address', { type: String, required: true }) vAddress!: string
  protected isMine = true
  protected destinationAddress = ''

  @Watch('isMine', { immediate: true })
  protected onIsMineChange(value: boolean) {
    this.handleAddressUpdate(value ? this.accountId : this.destinationAddress)
  }

  @Emit('update:address')
  protected handleAddressUpdate(value: string) {
    return value
  }
}
